import AbstractContext from '@/shared/models/AbstractContext';
import CommonFilters from '@/shared/models/CommonFilters';
import { removeById } from '@/shared/utils';
import Booking, { BookingId } from './Booking';

export default class BookingOverviewContext extends AbstractContext {
  constructor(
    public filters: CommonFilters,
    public bookings: Array<Booking>,
  ) {
    super();
  }

  removeBooking(bookingId: BookingId): void {
    removeById(this.bookings, bookingId);
  }
}